import * as api from '../../api/api-informes-profesionales';
import {
    OBTENER_LLAVES,
    GET_CONFIG_FORMINF,
    GET_TIPOS_INFORME_PROF,
    GET_GESTOR,
    GET_ESTADOS,
    GET_RESPONSABLES,
    GET_CRITERIOS_FECHA_PROF,
    GET_INFORMES_PREVIOS_PROF,
    POST_GENERAR_INFORME_PROF

} from '../types';


export const obtenerDatosLlaves = (llaves) => ({
    type:OBTENER_LLAVES,
    payload: llaves
});
export const configuracionFormAction = (query) => ({
    type: GET_CONFIG_FORMINF,
    payload: api.getConfiguracionForm(query)
});
export const obtenerTiposInforme = (query) => ({
    type: GET_TIPOS_INFORME_PROF,
    payload: api.getDetalles(query)
});
export const obtenerGestores = (query) => ({
    type: GET_GESTOR,
    payload: api.getGestores(query)
});
export const obtenerEstados = (query) => ({
    type: GET_ESTADOS,
    payload: api.getDetalles(query)
});
export const obtenerResponsables = (query) => ({
    type: GET_RESPONSABLES,
    payload: api.getResponsables(query)
});
export const obtenerCriteriosFecha = (query) => ({
    type: GET_CRITERIOS_FECHA_PROF,
    payload: api.getDetalles(query)
});
export const obtenerInformesPrevios = (query) => ({
    type: GET_INFORMES_PREVIOS_PROF,
    payload: api.getInformesPrevios(query)
});
export const generarInforme = (data) => ({
    type: POST_GENERAR_INFORME_PROF,
    payload: api.postGenerarInforme(data)
});